<template>
  <div class="md:flex md:flex-col" id="dropdown">
    <div class="md:flex md:flex-col md:h-screen">
      <div v-if="user?.super_admin_agency" class="py-2 bg-purple-100 text-white text-center">
        <Link href="agencies/return">Clique aqui para voltar ao administrador</Link>
      </div>
      <div class="md:flex md:flex-grow md:overflow-hidden">
        <main-menu :collapse="true" class="hidden flex-shrink-0 p-3 overflow-y-auto md:block" :routes="this.menuItems"
          @logout="openLogoutConfirm" @trigger-action="handleMenuAction" />

        <div class="flex flex-col w-full justify-between overflow-hidden bg-gray_bg">
          <div
            class="px-2 py-8 md:flex-1 md:p-6 md:overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200"
            scroll-region>
            <div class="md:text-md flex justify-end items-center p-4 w-full text-sm md:px-12 md:py-0">
              <notifications />
              <dropdown class="md:hidden" placement="bottom-end">
                <template #default>
                  <svg class="w-6 h-6 fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                  </svg>
                </template>
                <template #dropdown>
                  <div class="mt-2 px-8 py-4 bg-blue-900 rounded shadow-lg">
                    <main-menu :routes="this.menuItems" @logout="openLogoutConfirm"
                      @trigger-action="handleMenuAction" />
                  </div>
                </template>
              </dropdown>
            </div>

            <flash-messages />

            <div class="bg mt-8">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal de confirmação de saída -->
  <modal-delete ref="logoutModal" :show-trash-icon="false" />
  <unified-chat-modal v-if="user" ref="chatModal" @update-unread-count="updateChatUnreadCount" />
</template>

<script>
import { computed } from 'vue'
import { usePage, Link } from '@inertiajs/inertia-vue3'

import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import Notifications from './Notifications.vue'
import ModalDelete from '@/Shared/ModalDelete'
import UnifiedChatModal from '@/Shared/UnifiedChat/UnifiedChatModal.vue'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    MainMenu,
    Notifications,
    ModalDelete,
    UnifiedChatModal,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      chatUnreadCount: 0,
      menu: {
        agency: [
          {
            label: "Dashboard",
            icon: "fa-chart-column",
            link: "/",
          },
          {
            label: "Cadastro de promotores",
            icon: "fa-regular fa-star",
            link: "/sales_promoter",
          },
          {
            label: "Cadastro de redes",
            icon: "fa-cart-shopping",
            link: "/market_network",
          },
          {
            label: "Agenda do promotor",
            icon: "fa-regular fa-calendar",
            link: "/visiting_rules",
          },
          {
            label: "Regiões",
            icon: "fa-earth-americas",
            link: "/zone",
          },
          {
            label: "Fornecedores",
            icon: "fa-regular fa-clipboard",
            link: "/provider",
          },
          {
            label: "Chat",
            icon: "fa-comment-dots",
            link: "/admin/chat",
            action: "open-admin-chat",
            badge: () => this.chatUnreadCount,
          },
          {
            label: "Importação",
            icon: "fa-upload",
            link: "/import",
          },
          {
            label: "Relatório semanal",
            icon: "fa-regular fa-file",
            link: "/week_report",
          },
          {
            label: "Relatório mensal",
            icon: "fa-regular fa-file-lines",
            link: "/monthly_report",
          },
          {
            label: "Gerenciamento de atividades",
            icon: "fa-list-check",
            link: "/activity_management",
          },
          {
            label: "Feed de atividades",
            icon: "fa-list-check",
            link: "/activity_management/feed",
          },
          {
            label: "Material de apoio",
            icon: "fa-file-pdf",
            link: "/support_materials",
          },
          {
            label: "Regras",
            icon: "fa-list-check",
            link: "/shelf_life_rules",
          },
          {
            label: "Dashboard validade",
            icon: "fa-barcode",
            link: "/shelf_life_rule_dashboard",
          },
          {
            label: "Cadastro de notificação",
            icon: "fa-regular fa-bell",
            link: "/notification",
          },
          {
            label: "Perfil",
            icon: "fa-user",
            link: "/profile",
          },
          {
            label: "Sair",
            icon: "fa-right-from-bracket",
            link: "/logout",
          },
        ],
        admin: [
          {
            label: "Dashboard",
            icon: "fa-chart-column",
            link: "/",
          },
          {
            label: "Gestão de empresas",
            icon: "fa-regular fa-star",
            link: "/agencies",
          },
          {
            label: "Chat",
            icon: "fa-comment-dots",
            link: "/admin/chat",
            action: "open-admin-chat",
            badge: () => this.chatUnreadCount,
          },
          {
            label: "Termos de Uso",
            icon: "fa-info",
            link: "/terms",
          },
          {
            label: "Perfil",
            icon: "fa-user",
            link: "/profile",
          },
          {
            label: "Sair",
            icon: "fa-right-from-bracket",
            link: "/logout",
          },
        ]
      }
    };
  },
  computed: {
    menuItems: function () {
      return this.user.role == 1 || this.user?.super_admin_agency ? this.menu.agency : this.menu.admin;
    },
  },
  methods: {
    openLogoutConfirm() {
      const msg = 'Deseja realmente sair?'
      this.$refs.logoutModal && this.$refs.logoutModal.openModalDelete({}, '/logout', msg)
    },
    handleMenuAction(action) {
      if (action === 'open-admin-chat') {
        this.$refs.chatModal && this.$refs.chatModal.openModal()
      }
    },
    updateChatUnreadCount(count) {
      this.chatUnreadCount = count || 0
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {
  },
}
</script>
